import { render, staticRenderFns } from "./ticketsList.vue?vue&type=template&id=4606f80a&scoped=true&"
import script from "./ticketsList.vue?vue&type=script&lang=js&"
export * from "./ticketsList.vue?vue&type=script&lang=js&"
import style0 from "./ticketsList.vue?vue&type=style&index=0&id=4606f80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4606f80a",
  null
  
)

export default component.exports